import React, { useEffect } from 'react';
import { Drawer, Form, Button, InputNumber, Notification, useToaster, Message } from 'rsuite';
import { useDispatch } from 'react-redux';
import { updateUserBalance } from '@/services/balance.service';
import { useTranslation } from 'react-i18next';


interface EditDrawerViewProps {
  open: boolean;
  onClose: () => void;
  selectedUser?: any;
  currentTab: string;
}

const EditDrawerView: React.FC<EditDrawerViewProps> = ({ open, onClose, selectedUser, currentTab }) => {
  const dispatch = useDispatch();
  const toaster = useToaster();
  const [formValue, setFormValue] = React.useState({
    leaveBalance: 0,
    sickBalance: 0,
    comment: ''
  });

  useEffect(() => {
    if (selectedUser) {
      setFormValue({
        leaveBalance: selectedUser.LeaveBalance || 0,
        sickBalance: selectedUser.sickBalance || 0,
        comment: ''
      });
    }
  }, [selectedUser]);
  const { t } = useTranslation();

  const handleSubmit = () => {
    try {
      if (selectedUser && selectedUser._id) {
        dispatch(updateUserBalance(
          selectedUser._id, 
          {
            LeaveBalance: formValue.leaveBalance,
            sickBalance: formValue.sickBalance,
            comment: formValue.comment
          },
          currentTab
        ))
        .then(() => {
          toaster.push(
            <Message type="success" duration={3000}>
              {t('Balance updated successfully')}
            </Message>,
            { placement: 'topCenter' }
          );
          onClose();
        });
      }
    } catch (error) {
      toaster.push(
        <Message type="error" showIcon>
         {t(' Failed to update balance:')} {t(error.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>
          {t('Edit Leave Balance')} - {selectedUser?.idUser?.firstname} {selectedUser?.idUser?.lastname}
        </Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary">{t('Save')}</Button>
          <Button onClick={onClose} appearance="subtle">{t('Cancel')}</Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Leave Balance')}</Form.ControlLabel>
            <Form.Control 
              name="leaveBalance" 
              accepter={InputNumber} 
              min={0}
              step={0.5}
            />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>{t('Sick Balance')}</Form.ControlLabel>
            <Form.Control 
              name="sickBalance" 
              accepter={InputNumber} 
              min={0}
              step={0.5}
            />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>{t('Comment')}</Form.ControlLabel>
            <Form.Control 
              name="comment" 
              componentClass="textarea" 
              rows={3}
              placeholder={t("Add a comment for this balance update")}
            />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default EditDrawerView;
